let all_service_categories = [
  {
    id: 1,
    name: "Pet Boarding & Training",
    category: "training",
    desc: "Meet Best Professionals to train your pet's",
    image: "flaticon-house",
  },
  {
    id: 2,
    name: "Pet Grooming",
    category: "grooming",
    desc: "Book an appointment to the nearest Grooming store",
    image: "flaticon-grooming",
  },
  {
    id: 3,
    name: "Pet Treatment",
    category: "treatment",
    desc: "Book an Appointment with the nearest vet",
    image: "flaticon-vaccine",
  },
  {
    id: 4,
    name: "Nearest Pet Park",
    category: "parks",
    desc: "Find the nearest pet park",
    image: "flaticon-fountain",
  },
];

export default all_service_categories;
